import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import router from './router'; // Ajustează calea către router-ul tău
import store from './store'; // Ajustează calea către store-ul tău

// Request interceptor: attach token if present
axios.interceptors.request.use(
    (config) => {
        try {
            const token = localStorage.getItem('token') || store.getters['auth/getToken'];
            if (token && !config.headers['Authorization']) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        } catch (e) {}
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            Bugsnag.notify(error, (event) => {
                event.severity = error.response.status >= 500 ? 'error' : 'warning';
                event.context = 'API Request Error';

                // Add request metadata
                event.addMetadata('request', {
                    url: error.config?.url,
                    method: error.config?.method?.toUpperCase(),
                    baseURL: error.config?.baseURL,
                    headers: error.config?.headers,
                    data: error.config?.data,
                    params: error.config?.params,
                });

                // Add response metadata
                event.addMetadata('response', {
                    status: error.response.status,
                    statusText: error.response.statusText,
                    data: error.response.data,
                    headers: error.response.headers,
                });

                // Add user context if available
                const user = store.getters['auth/getFullUser'];
                if (user) {
                    event.setUser(user.id, user.email, user.name);
                }

                // Add additional context
                try {
                    event.addMetadata('context', {
                        currentRoute: router.currentRoute.value.fullPath,
                        routeName: router.currentRoute.value.name,
                    });
                } catch (e) {}
            });

            // Handle 401 Unauthorized
            if (error.response.status === 401) {

            }

            // Handle 403 Forbidden
            if (error.response.status === 403) {
                console.error('Access denied:', error.response.data?.message || 'Forbidden');
            }

            // Handle 419 CSRF Token Mismatch (Laravel specific)
            if (error.response.status === 419) {
                window.location.reload();
            }
        } else if (error.request) {
            // The request was made but no response was received (network error)
            Bugsnag.notify(error, (event) => {
                event.severity = 'warning';
                event.context = 'Network Error - No Response';
                event.addMetadata('request', {
                    url: error.config?.url,
                    method: error.config?.method?.toUpperCase(),
                    timeout: error.config?.timeout,
                });

                // Add user context if available
                const user = store.getters['auth/getFullUser'];
                if (user) {
                    event.setUser(user.id, user.email, user.name);
                }
            });
        } else {
            // Something happened in setting up the request
            Bugsnag.notify(error, (event) => {
                event.severity = 'error';
                event.context = 'Axios Configuration Error';
                event.addMetadata('error', {
                    message: error.message,
                    config: error.config,
                });
            });
        }

        return Promise.reject(error);
    }
);

export default axios;
